export default __webpack_public_path__ + "static/media/epson.dedd0e76.png";